<ng-container [formGroup]="filterForm">
  <mat-toolbar class="mat-toolbar-transparent">
    <mat-icon>filter_list</mat-icon>
  </mat-toolbar>
  <div class="wrapper--spacing-horizontal">
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'isCorrupt' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'isCorrupt' | translate"
          matInput
          formControlName="isCorrupt"
          [matAutocomplete]="isCorruptAutocomplete"
          data-test="template-filter-corrupt-input"
        />
        <mat-autocomplete
          #isCorruptAutocomplete="matAutocomplete"
          [displayWith]="displayIsCorrupt() | async"
        >
          @for (option of isCorruptValues; track option.value) {
            <mat-option [value]="option.value" data-test="template-filter-type-option">
              {{ option.text }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'treatmentType' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'treatmentType' | translate"
          matInput
          formControlName="templateType"
          [matAutocomplete]="templateTypeAutocomplete"
          data-test="template-filter-type-input"
        />
        <mat-autocomplete
          #templateTypeAutocomplete="matAutocomplete"
          [displayWith]="displayTemplateType() | async"
        >
          @for (option of templateTypes; track option.value) {
            <mat-option [value]="option.value" data-test="template-filter-type-option">
              {{ option.text }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'crop' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'crop' | translate"
          matInput
          formControlName="cropId"
          [matAutocomplete]="cropAutocomplete"
          data-test="template-filter-crop-input"
        />
        <mat-autocomplete
          #cropAutocomplete="matAutocomplete"
          [displayWith]="displayCrop$() | async"
        >
          @for (option of filteredCrops$ | async; track option.id) {
            <mat-option [value]="option.id" data-test="template-filter-crop-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'soilType' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'soilType' | translate"
          matInput
          formControlName="soilTypeId"
          [matAutocomplete]="soilAutocomplete"
          data-test="template-filter-soil-input"
        />
        <mat-autocomplete
          #soilAutocomplete="matAutocomplete"
          [displayWith]="displaySoil$() | async"
        >
          <mat-option [value]="0" data-test="template-filter-soil-option">{{
            'soilTypeIndependent' | translate
          }}</mat-option>
          @for (option of filteredSoils$ | async; track option.id) {
            <mat-option [value]="option.id" data-test="template-filter-soil-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'province' | translate }}</mat-label>
        <mat-select formControlName="provinces">
          @for (option of provincesArray; track option) {
            <mat-option [value]="option.value" data-test="template-filter-province-option">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropAid' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'cropAid' | translate"
          matInput
          formControlName="cropAidId"
          [matAutocomplete]="cropAidIdAutocomplete"
          data-test="template-filter-crop-aid-input"
        />
        <mat-autocomplete
          #cropAidIdAutocomplete="matAutocomplete"
          [displayWith]="displayCropAid$() | async"
        >
          @for (option of filteredCropAids$ | async; track option.id) {
            <mat-option [value]="option.id" data-test="template-filter-crop-aid-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="mat-button-row flex--justify-end">
      <button
        mat-button
        (click)="resetFilter()"
        [disabled]="(filterEnabled | async) === false"
        data-test="filter-reset"
      >
        <mat-icon>clear</mat-icon> {{ 'resetFilter' | translate }}
      </button>
    </div>
  </div>
</ng-container>
